import { useMemo } from 'react';
import roundTo from 'functions/roundTo';
import useCurrentBreakPoint from 'hooks/useCurrentBreakPoint';

const CARD_TAG_REGULAR_BREAKPOINTS = {
  1920: {
    itemsPerView: 6,
    itemRelativeWidth: roundTo(100 / 6, 2),
    itemRelativeHeight: 120,
  },
  1440: {
    itemsPerView: 6,
    itemRelativeWidth: roundTo(100 / 6, 2),
    itemRelativeHeight: 120,
  },
  1200: {
    itemsPerView: 5,
    itemRelativeWidth: roundTo(100 / 5, 2),
    itemRelativeHeight: 120,
  },
  1025: {
    itemsPerView: 4,
    itemRelativeWidth: roundTo(100 / 4, 2),
    itemRelativeHeight: 120,
  },
  768: {
    itemsPerView: 3,
    itemRelativeWidth: roundTo(100 / 3, 2),
    itemRelativeHeight: 120,
  },
  500: {
    itemsPerView: 2,
    itemRelativeWidth: roundTo(100 / 2, 2),
    itemRelativeHeight: 120,
  },
};

/**
 * @typedef {Object} CardTagRegularBreakpoint - config of the breakpoint
 *
 * @property {Number} itemsPerView - how many cards fit on the screen
 * @property {Number} itemRelativeWidth - card width as percentage relative to the parent
 * @property {Number} itemRelativeHeight - card height as percentage relative to the ITEM WIDTH
 */

/**
 * Function returns config for current breakpoint
 *
 * @returns {CardTagRegularBreakpoint}
 */
export const useCardTagRegularBreakpoint = () => {
  const breakpointKey = useCurrentBreakPoint(CARD_TAG_REGULAR_BREAKPOINTS);

  return useMemo(() => {
    return CARD_TAG_REGULAR_BREAKPOINTS[breakpointKey];
  }, [breakpointKey]);
};

/**
 * Function returns breakpoints for swiper slider
 *
 * @example:
 * {
 *   2250: {
 *     slidesPerView: 5,
 *   },
 *   1500: {
 *     slidesPerView: 4,
 *   },
 * }
 */
export const useCardTagRegularBreakpoints = () => {
  return useMemo(() => {
    return Object.keys(CARD_TAG_REGULAR_BREAKPOINTS).reduce((result, breakpointKey) => {
      return {
        ...result,
        [breakpointKey]: { slidesPerView: CARD_TAG_REGULAR_BREAKPOINTS[breakpointKey].itemsPerView },
      };
    }, {});
  }, []);
};
